export default "__VITE_ASSET__D70sj2Ej__"